import { combineReducers } from '@reduxjs/toolkit';

import { baseApi } from '@/api/baseApi';
import { uiReducer } from '@/app/uiSlice';
import { authReducer } from '@/features/auth/authSlice';

/**
 * One API slice holds every domain's endpoints (see baseApi), so there is exactly one cache
 * and two screens requesting the same data share one request. Feature slices are added here
 * as their phases land - authSlice in Phase 1, cartSlice in Phase 3.
 */
export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  auth: authReducer,
  ui: uiReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
